import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

interface CompanyConfig {
  id: string;
  company_name: string;
  company_address?: string;
  company_city?: string;
  company_state?: string;
  company_country?: string;
  company_email?: string;
  company_website?: string;
  company_phone?: string;
  company_logo_url?: string;
  company_logo_dark_url?: string;
  currency?: string;
  rnc?: string;
}

export const useCompanyConfig = () => {
  return useQuery({
    queryKey: ['company-config'],
    queryFn: async () => {
      try {
        const { data, error } = await supabase
          .from('company_config')
          .select('*')
          .single();

        if (error && error.code !== 'PGRST116') {
          console.error('Error al obtener configuración de empresa:', error);
          return null;
        }

        return data as CompanyConfig | null;
      } catch (error) {
        console.error('Error en consulta de configuración de empresa:', error);
        return null;
      }
    },
    staleTime: 5 * 60 * 1000, // 5 minutos
    retry: 1
  });
}; 